import type { ParsedThreadDetailPost } from "@/entities/post";
import { PostItem } from "../components/lists/PostItem";
import type { QuoteReferencesMap } from "../utils/extractQuoteReferences";

interface PostListDisplayProps {
  posts: Array<{ post: ParsedThreadDetailPost; index: number }>;
  header?: React.ReactNode;
  quoteReferencesMap?: QuoteReferencesMap;
  allPosts?: ParsedThreadDetailPost[];
  /** 親スレッドID (ULID string) */
  threadId?: string;
  onQuoteClick?: (quoteText: string) => void;
  onJumpToPost?: (postId: string) => void;
}

/**
 * モーダル内でのレス一覧表示用UIコンポーネント
 * SearchModal, PopularPostsModal, QuoteSearchModalなどで共通使用
 */
export const PostListDisplay: React.FunctionComponent<PostListDisplayProps> = ({
  posts,
  header,
  quoteReferencesMap,
  allPosts,
  threadId,
  onQuoteClick,
  onJumpToPost,
}: PostListDisplayProps) => {
  return (
    <div className="bg-muted/30">
      {header}
      {posts.map(({ post }) => (
        <PostItem
          key={post.id}
          post={post}
          isSubView
          quoteReferencesMap={quoteReferencesMap}
          allPosts={allPosts}
          threadId={threadId}
          onQuoteClick={onQuoteClick}
          onJumpToPost={
            onJumpToPost ? (): void => onJumpToPost(post.id) : undefined
          }
        />
      ))}
    </div>
  );
};
